import React from 'react';
import PropTypes from 'prop-types';
import Linkify from 'react-linkify';

import MessageDecorate from './MessageDecorate';
import styles from './TextMessage.scss';

TextMessage.propTypes = {
    ...MessageDecorate.propTypes,
    text: PropTypes.string.isRequired,
};

export default function TextMessage({ text, ...rest }) {
    return (
        <MessageDecorate {...rest}>
            <div className={styles.text}>
                <Linkify properties={{ target: '_blank' }}>{text}</Linkify>
            </div>
        </MessageDecorate>
    );
}
